import { defineMessages } from 'react-intl';

export const scope = 'app.components.BusinessCategorySection';

export default defineMessages({
  sectionTitle: {
    id: `${scope}.sectionTitle`,
    defaultMessage: 'Đề xuất theo loại hình',
  },
  sectionSubtitle: {
    id: `${scope}.sectionSubtitle`,
    defaultMessage: 'Giải pháp phù hợp cho từng loại doanh nghiệp',
  },
  restaurant: {
    id: `${scope}.restaurant`,
    defaultMessage: 'Nhà hàng',
  },
  cafe: {
    id: `${scope}.cafe`,
    defaultMessage: 'Cà phê',
  },
  bar: {
    id: `${scope}.bar`,
    defaultMessage: 'Bar - Club',
  },
  hotel: {
    id: `${scope}.hotel`,
    defaultMessage: 'Khách sạn',
  },
  supermarket: {
    id: `${scope}.supermarket`,
    defaultMessage: 'Cửa hàng/Siêu thị',
  },
  fbService: {
    id: `${scope}.fbService`,
    defaultMessage: 'Dịch vụ ăn uống',
  },
  trustBadge: {
    id: `${scope}.trustBadge`,
    defaultMessage: '5,000+ doanh nghiệp F&B tin dùng',
  },
});
